/**
 * @lodex-pro/web-shared/auth/sign-in-screen — the real SignInScreen: the shared layout
 * (sign-in-screen-view.tsx) built from the real flow pieces.
 */

import { EmailTotpFlow } from './email-totp-flow.js';
import { ForcedPasswordChange } from './forced-password-change.js';
import { ForgotPassword } from './forgot-password.js';
import { makeSignInScreen } from './sign-in-screen-view.js';

export { makeSignInScreen } from './sign-in-screen-view.js';
export type { SignInScreenParts, SignInScreenProps } from './sign-in-screen-view.js';

export const SignInScreen = makeSignInScreen({
  EmailTotpFlow,
  ForcedPasswordChange,
  ForgotPassword,
});
